var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 512,
    viewBox: "0 0 384 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.15 228.69H106.66V248.43H120.15C128.05 248.43 131.99 245.14 131.99 238.56C131.99 231.98 128.04 228.69 120.15 228.69Z",
    fill: "url(#paint0_linear_399_2818)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.12 238.56C206.12 231.98 202.17 228.69 194.28 228.69H180.79V248.43H194.28C202.18 248.43 206.12 245.14 206.12 238.56Z",
    fill: "url(#paint1_linear_399_2818)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.8 360.29H103.31V380.03H116.8C124.7 380.03 128.64 376.74 128.64 370.16C128.64 363.58 124.69 360.29 116.8 360.29V360.29Z",
    fill: "url(#paint2_linear_399_2818)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.97 361.16H177.44V405.79H187.97C195.65 405.79 201.33 403.94 205.02 400.25C208.71 396.56 210.56 390.95 210.56 383.42C210.56 375.89 208.7 370.3 204.97 366.64C201.24 362.99 195.57 361.16 187.97 361.16V361.16Z",
    fill: "url(#paint3_linear_399_2818)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136ZM160.61 223.43C160.61 220.14 161.49 217.62 163.24 215.86C164.99 214.1 167.52 213.23 170.81 213.23H197.79C206.56 213.23 213.34 215.48 218.13 219.97C222.92 224.47 225.31 230.66 225.31 238.56C225.31 246.46 222.91 252.65 218.13 257.15C213.34 261.65 206.56 263.89 197.79 263.89H180.79V281.33C180.79 284.62 179.93 287.14 178.21 288.9C176.49 290.65 173.99 291.53 170.7 291.53C167.41 291.53 165 290.65 163.24 288.9C161.49 287.15 160.61 284.62 160.61 281.33V223.43V223.43ZM140.65 388.75C135.86 393.25 129.08 395.49 120.31 395.49H103.31V412.93C103.31 416.22 102.45 418.74 100.73 420.5C99.01 422.25 96.51 423.13 93.22 423.13C89.93 423.13 87.52 422.25 85.76 420.5C84 418.75 83.13 416.22 83.13 412.93V355.03C83.13 351.74 84.01 349.22 85.76 347.46C87.51 345.7 90.04 344.83 93.33 344.83H120.31C129.08 344.83 135.86 347.08 140.65 351.57C145.44 356.07 147.83 362.26 147.83 370.16C147.83 378.06 145.43 384.25 140.65 388.75ZM143.99 257.15C139.2 261.65 132.42 263.89 123.65 263.89H106.65V281.33C106.65 284.62 105.79 287.14 104.07 288.9C102.35 290.65 99.85 291.53 96.56 291.53C93.27 291.53 90.86 290.65 89.1 288.9C87.35 287.15 86.47 284.62 86.47 281.33V223.43C86.47 220.14 87.35 217.62 89.1 215.86C90.85 214.1 93.38 213.23 96.67 213.23H123.65C132.42 213.23 139.2 215.48 143.99 219.97C148.78 224.47 151.17 230.66 151.17 238.56C151.17 246.46 148.77 252.65 143.99 257.15ZM220.43 411.99C213.05 418.75 202.66 422.13 189.29 422.13H167.8C160.78 422.13 157.27 418.66 157.27 411.71V355.23C157.27 348.29 160.78 344.81 167.8 344.81H189.29C202.67 344.81 213.05 348.17 220.43 354.9C227.81 361.63 231.51 371.13 231.51 383.41C231.51 395.69 227.82 405.22 220.43 411.98V411.99ZM290.5 360.39H263.63V375.96H288.08C293.34 375.96 295.98 378.52 295.98 383.64C295.98 388.76 293.35 391.43 288.08 391.43H263.63V412.7C263.63 419.65 260.3 423.12 253.65 423.12C250.43 423.12 247.93 422.22 246.14 420.43C244.35 418.64 243.45 416.06 243.45 412.7V355.24C243.45 348.3 246.96 344.82 253.98 344.82H290.5C295.76 344.82 298.4 347.38 298.4 352.5C298.4 357.62 295.77 360.4 290.5 360.4V360.39ZM296.92 221.45C296.92 226.93 294.14 229.67 288.59 229.67H271.37V281.32C271.37 284.61 270.51 287.13 268.79 288.89C267.07 290.64 264.57 291.52 261.28 291.52C257.99 291.52 255.58 290.64 253.82 288.89C252.07 287.14 251.19 284.61 251.19 281.32V229.67H233.97C228.41 229.67 225.64 226.93 225.64 221.45C225.64 215.97 228.42 213.23 233.97 213.23H288.58C294.13 213.23 296.91 215.97 296.91 221.45H296.92Z",
    fill: "url(#paint4_linear_399_2818)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105Z",
    fill: "url(#paint5_linear_399_2818)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_2818",
    x1: 106.66,
    y1: 228.69,
    x2: 106.66,
    y2: 248.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_399_2818",
    x1: 180.79,
    y1: 228.69,
    x2: 180.79,
    y2: 248.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_399_2818",
    x1: 103.31,
    y1: 360.29,
    x2: 103.31,
    y2: 380.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_399_2818",
    x1: 177.44,
    y1: 361.16,
    x2: 177.44,
    y2: 405.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_399_2818",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_399_2818",
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB522"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ab872ac50c96cb3216b1438355f70890.svg";
export { ForwardRef as ReactComponent };